<template>
  <div class="row">
    <div class="flex md12 xs12">
      <sp-360-panel class="chart-widget tree overflowDisabled" :title="headerText" :tooltipOptions="tooltipOptions">

        <va-tabs class="tabPadding" v-model="showTable">
          <va-tab v-for="option in showTableOptions" :key="option.atributo">
            {{ option.label }}
          </va-tab>
        </va-tabs>

        <div v-show="!showTable">
          <!-- <multiselect name="atributo" v-validate="'required'" :options="options" :searchable="false" v-model="atributo"
            :allow-empty="false" deselect-label="" @input="atualizaTreeSub" track-by="atributo" label="label"/> -->
           <grafico-tree :dados="dadosTree" ref="graficoArvore" class="treeContainer" identificador="medicamento" totalizador="cmm"></grafico-tree>
        </div>

        <!-- <sp360-data-table v-show="showTable" ref="tabelaPorSubUltimoMes" :apiMode="false"
          :data="dadosTabelaPorSubUltimoMes" :fields="tableFieldsPorSub" :perPage="itemsPerPage"
          :onEachSide="onEachSide" :dataModeFilterableFields="dataModeFilterableFields" :sortFunctions="sortFunctions"
          :footerObj="footerObj" /> -->
      </sp-360-panel>

    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import MetodosGlobais from '@/utils/MetodosGlobais'
import Constantes from '@/utils/ConstantesGlobais'
import CorUtil from '@/utils/CorUtils'
import GraficoTree from '@/components/statistics/charts/GraficoTreeMedicamento'
import Multiselect from 'vue-multiselect'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'
import Sp360DataTable from '@/components/ui/dataTable/sp360datatable'

export default {
  name: 'ranking-farmacia-medicamento',
  components: {
    GraficoTree,
    Multiselect,
    Sp360Panel,
    Sp360DataTable,
  },
  props: {
    filtro: {
      type: String,
      required: true,
      validator: value => {
        return ['F', 'M'].includes(value)
      },
    },
  },
  data () {
    return {
      selectedTabIndex: 0,
      showTable: 0,
      showTableOptions: [
        {
          atributo: 0,
          label: 'Gráfico',
        },
        {
          atributo: 1,
          label: 'Tabela',
        },
      ],
      dadosTree: [],
      solicitacoes30: {},
      topPorRegiao: {},
      options: [
        {
          atributo: 'recebidas',
          label: 'Recebidas',
        },
        {
          atributo: 'canceladas',
          label: 'Canceladas',
        },
        {
          atributo: 'finalizadas',
          label: 'Finalizadas',
        },
        {
          atributo: 'deferidas',
          label: 'Deferidas',
        },
        {
          atributo: 'indeferidas',
          label: 'Indeferidas',
        },
      ],
      // Atributo inicial a ser mostrado
      atributo: {
        atributo: 'recebidas',
        label: 'Recebidas',
      },
      itemsPerPage: Constantes.PARAMETROS_DASHBOARD.SP156.QTD_DE_LINHAS_TABELAS_SOLICITACOES_POR_ORGAO_ULTIMO_MES,
      dadosTabelaPorSubUltimoMes: [],
      onEachSide: 1,
      sortFunctions: {
        'taxaAbertura': MetodosGlobais.ordenaTabelaParseFloat,
        'finalizadas': MetodosGlobais.ordenaTabelaParseInt,
        'recebidas': MetodosGlobais.ordenaTabelaParseInt,
        'canceladas': MetodosGlobais.ordenaTabelaParseInt,
        'deferidas': MetodosGlobais.ordenaTabelaParseInt,
        'indeferidas': MetodosGlobais.ordenaTabelaParseInt,
      },
      footerObj: {},
    }
  },
  computed: {
    tabSelector: () => {
      return this.showTable
    },

    tooltipOptions: function () {
      let texto = ''

      switch (this.filtro) {
        case 'F': texto = 'Farmacias'
          break
        case 'M': texto = 'Medicamentos'
          break
      }

      return { content: this.$t(texto), placement: 'bottom' }
    },

    headerText: function () {
      switch (this.filtro) {
        case 'sub': return this.$t('graficos156.rankingRegiao')
        case 'orgao': return this.$t('graficos156.rankingOrgao')
      }
    },

    dataModeFilterableFields: function () {
      switch (this.filtro) {
        case 'sub': return ['nome']
        case 'orgao': return ['orgao']
      }
    },

    computedTableFields: function () {
      let objOrgao = [{
        name: 'orgao',
        title: this.$t('graficos156.tableFields.orgao'),
        width: '40%',
      }]

      let objSub = [{
        name: 'nome',
        title: this.$t('graficos156.tableFields.sub'),
        width: '40%',
      }]
      switch (this.filtro) {
        case 'F': return objSub
        case 'M': return objOrgao
      }
    },

    tableFieldsPorSub: function () {
      return [
        ...this.computedTableFields,
        {
          name: 'cnes',
          sortField: 'cnes',
          title: 'Farmacia',
          callback: MetodosGlobais.thousandSeparator,
          width: '12%',
        },
        {
          name: 'medicamento',
          sortField: 'medicamento',
          title: 'Mediacamento',
          width: '25%',
        },
        {
          name: 'cobertura_rede_dias',
          sortField: 'cobertura_rede_dias',
          title: 'Cobertura (dias)',
          callback: MetodosGlobais.thousandSeparator,
          width: '10%',
        },
        {
          name: 'perc_estoque',
          sortField: 'perc_estoque',
          title: 'Estoque (%)',
          callback: MetodosGlobais.thousandSeparator,
          width: '10%',
        },
      ]
    },

    storeURL: function () {
      switch (this.filtro) {
        case 'F': return 'saude/buscarMedicamentosPorFarmacia'
        case 'M': return 'saude/buscarMedicamentosPorFarmacia'
      }
    },

  },
  beforeMount () {
    this.atualizaTreeSub()
      .then(() => {
        this.populateTableSub(this.dados)
      })
  },
  methods: {
    populateTableSub (dados) {
      if (dados) {
        this.medicamentosOrdenadosPorEstoque = _.orderBy(dados, 'cobertura_rede_dias', ['asc'])
        // this.footerObj.total = MetodosGlobais.thousandSeparator(this.footerObj.total || 0)
        // this.footerObj.finalizadas = MetodosGlobais.thousandSeparator(this.footerObj.finalizadas || 0)
        // this.footerObj.recebidas = MetodosGlobais.thousandSeparator(this.footerObj.recebidas || 0)
        // this.footerObj.abertas = MetodosGlobais.thousandSeparator(this.footerObj.abertas || 0)
        // this.footerObj.estoque = MetodosGlobais.thousandSeparator(this.footerObj.abertas || 0)
      }
    },
    updateDadosUltimoMes (novosDados) {
      this.solicitacoes30 = novosDados
      this.populateTreePorSub(this.solicitacoes30.data, this.atributo)
    },
    populateTreePorSub (dados, atributo) {
      this.$set(this, 'dadosTree', dados)
      this.$refs.graficoArvore.carregamentoInicial(_.cloneDeep(this.dados))
    },
    atualizaTreeSub () {
      // Verifica se o conteúdo já foi salvo, para não ter que repetir requests
      // eslint-disable-next-line no-constant-condition
      if (false) {
        this.populateTreePorSub(this.dados)
        return Promise.resolve()
      } else {
        return this.$store.dispatch(this.storeURL, { topReqs: Constantes.PARAMETROS_DASHBOARD.SP156.QTD_SERVICOS_POR_REGIAO_ULTIMO_MES_REQUEST, intervalo: 'ULTIMO_MES', ordenacao: this.atributo.atributo })
          .then((retorno) => {
            this.dados = retorno.data.data
            // this.solicitacoes30[this.atributo.atributo] = retorno.data.data
            let a = retorno.data.data.slice(0, 100)
            this.populateTreePorSub(a)
            return Promise.resolve()
          })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
  .treeContainer{
          height: 850px;
  }
  .tabPadding {
    padding-bottom: 20px;
  }
  .overflowDisabled {
    overflow: visible;
  }

</style>
